import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { UiModule } from '../../shared/ui/ui.module';
import { MessageModule } from '../../shared/message/message.module';
import { TopBannerModule } from '../top-banner/top-banner.module';
import { DiscussionBoardModule } from '../../shared/components/discussion-board/discussion-board/discussion-board.module';

import { ApproverComponent } from './approver.component';
import { ApproverTableComponent } from './approver-table/approver-table.component';
import { ApproveModalComponent } from './approve-modal/approve-modal.component';
import { RejectModalComponent } from './reject-modal/reject-modal.component';
import { ApproverChatModalComponent } from './approver-chat-modal/approver-chat-modal.component';

@NgModule({
  declarations: [
    ApproverComponent,
    ApproverTableComponent,
    ApproveModalComponent,
    RejectModalComponent,
    ApproverChatModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
    MessageModule,
    TopBannerModule,
    DiscussionBoardModule
  ]
})
export class ApproverModule { }
